import { PimProductT, VendorDetails } from '@lambda/apis/src/dynamoDb/types';
import { ReplacedProduct } from '@/lib/collections/catalogue/helpers';
import { DispatchType } from '@/lib/use-vendor-details';
import { ZipcodeStateData } from '@/lib/use-customer-zipcode';
import { ProductDetailsT } from '@/settings/types';

import VendorInfoSection from './VendorInfoSection';
import SpecificationSlideDown from './SpecificationsSlideDown';
import QualityPackagingSlideDown from './QualityPackagingSlideDown';
import KeyFeatures from './KeyFeatures';
import { isTech } from '@/lib/collections/helpers';

type AboutProductSectionProps = {
  product: PimProductT;
  offer: ReplacedProduct;
  isUnfitProduct: boolean;
  dispatch: DispatchType;
  zipcodeStateData: ZipcodeStateData | null;
  setZipcodeStateData: (data: ZipcodeStateData) => void;
  vendor: string;
  productDetails: ProductDetailsT;
  vendorInfo: VendorDetails | undefined;
  categorySummary?: string;
};

const AboutProductSection = (props: AboutProductSectionProps) => {
  const {
    product,
    dispatch,
    zipcodeStateData,
    setZipcodeStateData,
    vendor,
    productDetails,
    vendorInfo,
    categorySummary,
  } = props;

  const shouldShowSpecifications =
    product.specifications != null && product.specifications.length > 0;
  const shouldShowKeyFeatures =
    ['Smartphones', 'Smartwatches', 'Tablets'].includes(product.category) &&
    product.keyFeatures != null &&
    product.keyFeatures.length > 0;

  const isTechProduct = isTech(product.category);

  return (
    <div className="mt-4 bg-white text-gray-700">
      {(shouldShowSpecifications || isTechProduct || shouldShowKeyFeatures) && (
        <div>
          <h3 className="mb-1 text-lg font-bold">About this item</h3>
          <div className="mb-4 rounded-md border border-gray-200">
            {shouldShowKeyFeatures && (
              <KeyFeatures keyFeatures={product.keyFeatures} />
            )}
            {shouldShowSpecifications && (
              <SpecificationSlideDown
                specifications={product.specifications}
                product={product}
              />
            )}
            {categorySummary && (
              <QualityPackagingSlideDown categorySummary={categorySummary} />
            )}
          </div>
        </div>
      )}
      {/* Vendor Section + Payment  */}
      <VendorInfoSection
        dispatch={dispatch}
        zipcodeStateData={zipcodeStateData}
        setZipcodeStateData={setZipcodeStateData}
        vendor={vendor}
        productDetails={productDetails}
        vendorInfo={vendorInfo}
      />
    </div>
  );
};

export default AboutProductSection;
